import { Context, useContext } from 'react'
import { __RouterContext, RouteComponentProps } from 'react-router'

type AnyContext = Context<RouteComponentProps<any, any, any>>

export function useReactRouter () {
  const context: RouteComponentProps = useContext(__RouterContext as AnyContext)
  return context
}
